module.exports = __webpack_public_path__ + "0df22d73980abd2fe2371870f3eb7cac.pdf";